<template>
  <div class="login-container">
    <div class="row sentence error" style="text-align: justify;">{{ $t("message.user_or_guest") }}</div>
        <InputText type="text" :placeholder='$t("message.input_username")' v-model="username" class="row" />
        <Password :placeholder='$t("message.input_password")' v-model="password" class="row" style="width:100%" :feedback="false" :toggleMask="true" />
    <div class="row">
        <Button :label='$t("message.login")' @click="login()" class="full-width"/>
    </div>
    <div class="row">
        <Button :label="$t('message.i_am_a_guest')" @click="imguest()" class="p-button-warning full-width"/>
    </div>
  </div>
</template>

<script>
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';
import Button from 'primevue/button';
import axios from 'axios';

export default {
  name: 'LoginPage',
  inject: ['dialogRef'],
  components: {
    InputText,
    Password,
    Button
  },
  data(){
    return {
      username:'',
      password:''
    }
  },
  props: {
  },
  methods:{
    login(){

        axios
        .post(this.$common.HOST+'/site/login.html?client=scan&qrid='+this.$common.qrid,{username:this.username,password:this.password})
        .then(response => {

            const result=response.data;

            if(result.status==1)
            {

                this.$common.userid=result.id;

                this.$common.roles=result.roles;

                this.$common.access_token=result.token;

                /*
                if(this.$common.entry)
                {
                  const pg = this.initEntry(this.$common.login_redirect);

                  if(pg!='login')
                      this.$router.push({path:'/', query:{k:this.$common.key, s:this.$common.sk, p:pg},replace:true});

                }
                else
                  this.$common.gotoLink(this.$common.router,this.$common.login_redirect);*/

                this.dialogRef.close();

            }
            else{
              this.$toast.add({severity:'error', summary: this.TITLE, detail:this.$t("message.invalid_username_password"), life: 3000});
            }

        })
        .catch(() => {
              
          this.$toast.add({severity:'error', summary: this.TITLE, detail:this.$t("message.login_error"), life: 3000});

        })

    },
    imguest(){

        this.dialogRef.close();

    }

  },
  created(){


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .login-container{
    height:100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding:1rem 3rem;
  }
  .login-container:last-child{
    margin-bottom: 0px;
  }
  .row{
    margin-bottom:1rem !important;
    width:100%;
  }
  .sentence{
    line-height: 1.5rem;
  }
  .error{
    color:#73000c;
    margin-top: 2rem;
  }
  
  .full-width{
    width:100%;
  }    
</style>